module.exports = __webpack_public_path__ + "static/media/twitter-red.f294e5c8.png";